import { defineComponent as _defineComponent } from 'vue'
import type { NewPerPackageModuleFragment } from '@/features/onboarded-home/types';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import NewOnYourServicesTitleList from '@/features/onboarded-home/components/modules/new-on-your-services/NewOnYourServicesTitleList.vue';

import { CollectionType } from '@/enums/collection-type';

import { SnowplowTitleContextGraphql } from '@/helpers/tracking/providers';
import { useRouter } from 'vue-router/composables';
import { useFilterStore } from '@/helpers/composables/useStores';
import { useHomeModuleTracking } from '@/features/onboarded-home/tracking';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewOnYourServicesModule',
  props: {
    moduleData: null,
    globalPosition: null,
    localPosition: null
  },
  setup(__props: any) {

const props = __props as {
	moduleData: NewPerPackageModuleFragment;
	globalPosition: number;
	localPosition?: number;
};



const router = useRouter();
const { reset } = useFilterStore();

const newUrl = computed(() => router.resolve({ name: 'app.titles.new.list' }).href);

const { moduleContext, moduleObserveVisibility, trackHomeModule } = useHomeModuleTracking({
	moduleData: () => props.moduleData,
	globalPosition: () => props.globalPosition,
	localPosition: () => props.localPosition,
});

function trackTitleClicked(...contextData: Parameters<typeof SnowplowTitleContextGraphql.fromTitle>) {
	trackHomeModule('titleClicked', {
		spec: { label: moduleContext.value.type },
		contexts: [SnowplowTitleContextGraphql.fromTitle(...contextData)],
	});
}

return { __sfc: true,props, router, reset, newUrl, moduleContext, moduleObserveVisibility, trackHomeModule, trackTitleClicked, HiddenHorizontalScrollbar, NewOnYourServicesTitleList, CollectionType }
}

})